import classNames from 'classnames'
import React from 'react'
import { PAGE_ADDRESS_NAME } from '../analytics/PageTagsService'
import { ETA } from '../genericComponents/ETA'
import GoToItineraryButton from '../genericComponents/GoToItineraryButton'
import s from './EtaAndItineraryButton.less'

const EtaAndItineraryButton = ({ location }) => {
  if (!location) return <></>

  return (
    <div className={classNames(s.subHeader, s.address)}>
      <div>
        <ETA coordinates={location.coordinates} />
      </div>
      <div>
        <GoToItineraryButton
          location={location}
          tagProps={{
            tagInfo: {
              ancrage: PAGE_ADDRESS_NAME
            }
          }}
        />
      </div>
    </div>
  )
}

export default EtaAndItineraryButton
